export const localFeatureIds = [
  //
  'export video',
  'profitwell cancel flow',
  'ss onboarding',
  'pause-cancellation',
  'smartlook-canvas',
  'professional-1-name',
  'viz-options',
  'signup-promo-code',
  'ss-spoak-sign',
  'magic-paint',
  'rich-color-filter',
  'autocomplete-brand-import',
  'mobile-viz',
  'demo-sidepanel',
] as const

export const externalFeatureIds = [
  //
  'smartlook-canvas',
  'professional-1-name',
  'signup-promo-code',
  'ss-spoak-sign',
  'magic-paint',
  'rich-color-filter',
  'autocomplete-brand-import',
  'mobile-viz',
  'demo-sidepanel',
] as const

export type LocalFeatureId = (typeof localFeatureIds)[number]
export type ExternalFeatureId = (typeof externalFeatureIds)[number]
export type FeatureId = LocalFeatureId | ExternalFeatureId

export function isLocalFeature(
  featureId: FeatureId,
): featureId is LocalFeatureId {
  return localFeatureIds.includes(featureId as LocalFeatureId)
}

export function isExternalFeature(
  featureId: FeatureId,
): featureId is ExternalFeatureId {
  return externalFeatureIds.includes(featureId as ExternalFeatureId)
}
